import React, { PureComponent, Fragment } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';

import Home from './home/home.container';
import About from './about/about.component';
import ProgramDetails from './programDetails/programDetails.component';
import Abonament from './abonament/abonament.container';
import Invoice from './invoice/invoice.container';
import Contact from './contact/contact.component';
import Subsite from './textSubsite/textSubsite.component';
import Footer from 'components/footer/footer.component';


export class RootContainer extends PureComponent {
  render() {
    return (
      <Fragment>
        <Switch>
          <Route exact path="/" component={Home} />
          <Redirect from="/nasza-myjnia" to="/" />
          <Route path="/galeria" component={About} />
          <Route path="/program-myjni/:slug/:id" component={ProgramDetails} />
          <Route path="/oferta-dla-firm" component={Abonament} />
          <Route path="/faktura-vat" component={Invoice} />
          <Route path="/kontakt" component={Contact} />
          <Route path="/:slug" component={Subsite} />

        </Switch>
        <Footer/>
      </Fragment>
    );
  }
}

export default withRouter(RootContainer);



// WEBPACK FOOTER //
// ./src/routes/index.js